var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showType == 'form-builder')?_c('div',{staticClass:"separator",attrs:{"id":"page-break-v1-mip65p"}},[_vm._v("\n    Page Break\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }